module.exports = __webpack_public_path__ + "static/media/HTML5.16d07e86.svg";